import { Routes } from '@angular/router';
import { NotesPageComponent } from './notes-page.component';

/**
 * Created by Arturo Campos on 08/01/19.
 */
const routes: Routes = [{
    path: 'notes',
    component: NotesPageComponent,
    data: { impersonationAllowed: true }
}];
export default routes;



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/notes/notes-pages.routing.ts